
































































import { groupBy, merge, uniqBy } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import Icon from '../Icon/Icon.vue'
import ChoosePeriodCard from './components/ChoosePeriodCard.vue'
import CouponCard from './components/CouponCard/CouponCard.vue'
import { ActivateCouponStruct } from './components/CouponCard/types'
import MakePayment from './components/MakePayment.vue'
import MerchantSelectModal from './components/MerchantSelectModal.vue'
import ServiceCard from './components/ServiceCard.vue'
import ServicesShowcase from './components/ServicesShowcase.vue'
import { defaultShopTypeOfSelectedTariff } from './logic/helpers'
import { Payment, SelectedShop, Shop, ShortTariffInfo, Tariff } from './logic/types'
import { testPeriods } from './test-data'

@Component({
  data() {
    return {
      testPeriods,
      Shop,
    }
  },
  components: {
    MerchantSelectModal,
    ChoosePeriodCard,
    CouponCard,
    ServiceCard,
    ServicesShowcase,
    MakePayment,
    Icon
  },
})
export default class ServicesCart extends Vue {
  @Prop() readonly tariffs!: Array<Tariff>

  @Prop() readonly tariffImages!: { [key: string]: string }

  @Prop({ type: Boolean, default: false }) multiplePayment!: boolean

  @Prop({ type: Function }) calcTotalFn!: (price: string) => number

  @Emit()
  private activateCoupon(activateCouponStruct: ActivateCouponStruct): ActivateCouponStruct {
    return activateCouponStruct
  }

  @Emit()
  private paymentGenerated(payment: Payment): Payment {
    this.coupon ? payment.coupon = this.coupon : payment.coupon = null
    return payment
  }

  @Emit()
  updatePayInfo(info: Array<ShortTariffInfo>) {
    return info
  }

  selectedPeriod: number | null = null

  selectedTariff: Tariff | null = null

  initShop: SelectedShop | null = null

  private coupon = ''

  get hasLlc() {
    return this.tariffs.some(t => t.shops[Shop.Llc])
  }

  get tariffsValue(): Array<Tariff> {
    const groupedTariffs =  Object.entries(groupBy(this.tariffs, (t) => `${ t.name }-${ t.monthCount }`))
      .map(([ key, tariff ]) => {
        const tariffShops = tariff.map(v => v.shops)

        const shops = tariffShops.reduce<Partial<Tariff['shops']>>((acc, v) => {
          Object.entries(v).forEach(([ shop, shops ]) => {
            const s = shop as Shop

            if (!acc[s]) {
              acc[s] = shops
            } else {
              acc[s]!.push(...shops)
            }
          })

          return acc
        }, {})

        const item = tariff[0]
        item.shops = shops

        return [ key, item ]
      })

    return Object.values(Object.fromEntries(groupedTariffs))
  }

  private get periods(): Array<number> {
    const periods = this.tariffsValue
      .map((tariff: Tariff) => tariff.monthCount)
      .filter((value, index, self) => self.indexOf(value) === index)

    if (this.period === null) {
      this.period = periods[0]
    }

    return periods
  }

  get period(): number | null {
    return this.selectedPeriod
  }

  set period(period: number | null) {
    this.selectedPeriod = period
  }

  get defaultShop(): SelectedShop | null {
    for (const tariff of this.tariffsValue) {
      if (defaultShopTypeOfSelectedTariff(tariff.shops) !== null) {
        return defaultShopTypeOfSelectedTariff(tariff.shops)
      }
    }

    return null
  }

  get llcShop(): SelectedShop {
    return {
      "group": Shop.Llc,
      "currency_short_name": this.selectedTariff?.currency_short_name ?? "RUB"
    }
  }

  setLlcShop() {
    this.period = 12
    this.initShop = this.llcShop

    for (const tariff of this.tariffsValue) {
      if (tariff.shops[Shop.Llc]) {
        this.selectedTariff = tariff

        break;
      }
    }
  }
}
